import {useEffect} from 'react';
import API from '../../API';
import {getBannerURL, getProfilePictureURL, UserBadge} from '../../util/userUtil';
import Ad from '../../layout/Ad';
import {useDispatch} from 'react-redux';
import Head from 'next/head';
import Video from '../../components/Video';
import Error from '../../components/Error';
import {I18nText} from '../../i18n/I18nText';

export default function ViewModel({model, error}) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({type: 'navbar:setActiveCategory', val: 'cornstars'});
    }, []);

    if (error) {
        return <Error error={error}/>;
    }

    let displayName = model.display_name ?? model.username;
    let description = `CornHub is the world's leading free corn site. Check out corny videos by ${displayName} today!`;

    return <div className="p-3 max-w-1300px m-auto">
        <Head>
            <title>{`${displayName} - CornHub`}</title>

            <meta property="description" content={description} />
            <meta property="og:title" content={`${displayName} - CornHub`} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={getProfilePictureURL(model)} />
            <meta property="og:type" content="profile" />
        </Head>

        <div className="w-full h-200px bg-cover bg-no-repeat bg-center" style={{backgroundImage: `url(${getBannerURL(model)})`}}>
            <div className="pt-40px ml-5 flex">
                <img src={getProfilePictureURL(model)} alt="Avatar" width={160} height={160}/>
                <h1 className="text-2xl ml-2 font-bold mt-auto">{displayName}</h1>
                <UserBadge user={model} className="inline ml-1 mt-auto mb-2"/>
            </div>
        </div>

        {model.videos.length !== 0 ? <h1 className="text-xl mt-10 ml-3">
            <I18nText id="model.title" placeholders={{name: displayName}}/>
        </h1> : null}

        {model.videos.length !== 0 ? <div className="md:flex">
            <div className="pl-3 pr-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 w-full h-max">
                {model.videos.map((video) => <Video video={video} key={video.id} showUploader={false}/>)}
            </div>
            <div className="w-max md:pl-10 md:pr-10 m-auto">
                <Ad orientation="square" page="model" position="besides-videos" context={model.id}/>
                <Ad orientation="square" page="model" position="besides-videos" context={model.id} housePlease={true}/>
            </div>
        </div> : null}

        <div className="mt-10">
            <Ad orientation="horizontal" page="model" position="below-videos" context={model.id}/>
        </div>
    </div>;
}

ViewModel.getInitialProps = async ({req, res = {}, query}) => {
    const {id} = query;
    const {data, errored, status} = await API.get(`/user/${id}`, {req});

    if (errored) {
        if (status === 404) {
            res.statusCode = 404;
            return {error: {status: 404, message: '404 - Cornstar Not Found'}};
        }

        res.statusCode = 503;
        return {error: {status: 503}};
    }

    return {model: data};
}
